import { useIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { DialogFooter } from '../../../../feedback/Dialog';
import ProgressButton from '../../../../input/ProgressButton/ProgressButton';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ICreateCollectionDialogFooterProps } from './typings';

export const CreateCollectionDialogFooter: React.FC<ICreateCollectionDialogFooterProps> = ({
    selectedPosts,
    atBottom,
    onNextClick,
}) => {
    const t = useTranslation();
    const isMobile = useIsMobile();
    const content = (
        <>
            <Typography variant="body2" color="primary" pb={1.5}>
                {t('Для попадания в рекомендации добавьте от 4 постов')}
            </Typography>
            <ProgressButton
                dataTestId={DataTestId.CREATE_COLLECTION_NEXT}
                progress={selectedPosts.length / 4}
                disabled={!selectedPosts.length}
                onClick={onNextClick}
            >
                {t('Далее')}
            </ProgressButton>
        </>
    );

    if (isMobile) {
        return (
            <DialogFooter minHeight={110} withBorderTop={!atBottom}>
                <Flex direction="column" alignItems="center" width="100%">
                    {content}
                </Flex>
            </DialogFooter>
        );
    }

    return (
        <Flex
            direction="column"
            alignItems="center"
            width="100%"
            position="absolute"
            bottom={{ xs: 10, sm: 3 }}
            zIndex={2}
        >
            <Flex
                background="var(--background-primary)"
                borderRadius={2}
                p={2}
                boxShadow="0px 0px 4px 0px var(--control-primary-blur-background)"
            >
                {content}
            </Flex>
        </Flex>
    );
};
